import React from "react";
import { Helmet } from "react-helmet-async";

export function Page1Meta() {
  return (
    <Helmet>
      <meta name="title" content="Stock calculator page" />
      <meta
        name="description"
        content="calculate your own stock information."
      />
      <meta name="robots" content="index,nofollow" />
      <meta property="og:site_name" content="Stock calculator" />
      <meta property="og:title" content="Stock calculator page" />
      <meta property="og:url" content="https://hpb2.netlify.app/" />
      <meta
        property="og:description"
        content="1. Search for stocks that you want to know the average annual return. 
    2. Set a period and enter the year and amount at the beginning and end. 
    3. Press the 'Let me know ♡'
    button to see the annual
    return.
    4. If you enter the rest of the information, you can find out the amount you can get in the future.
    "
      />
    </Helmet>
  );
}

export function Page2Meta() {
  return (
    <Helmet>
      <meta name="title" content="Days Calculator: Days Between Two Dates" />
      <meta name="description" content="calculate your days information." />
      <meta name="robots" content="index,nofollow" />
      <meta property="og:site_name" content="D day calculator" />
      <meta property="og:title" content="D day calculator page" />
      <meta property="og:url" content="https://hpb2.netlify.app/dday/" />
      <meta
        property="og:description"
        content="Days Calculator: Days Between Two Dates"
      />
    </Helmet>
  );
}
